import { round } from '@homamo/meadow-utils';

export default function (months) {
  // Round months up
  const totalMonths = Math.ceil(months);
  // Find out if there are extra months than whole years
  const remainderMonths = totalMonths % 12;
  const years = (totalMonths - remainderMonths) / 12;

  const roundedRemainderMonths =
    years < 1 && remainderMonths < 1
      ? round(remainderMonths, 1)
      : round(remainderMonths, 0);

  const formatYrs = years && years === 1 ? `${years} year` : `${years} years`;
  const formatMths =
    roundedRemainderMonths && roundedRemainderMonths === 1
      ? `${roundedRemainderMonths} month`
      : `${roundedRemainderMonths} months`;

  if (years && roundedRemainderMonths) return `${formatYrs} ${formatMths}`;
  if (years) return formatYrs;

  return formatMths;
}
